import { render, staticRenderFns } from "./TodosView.vue?vue&type=template&id=1fbcd834&scoped=true"
import script from "./TodosView.vue?vue&type=script&lang=js"
export * from "./TodosView.vue?vue&type=script&lang=js"
import style0 from "./TodosView.vue?vue&type=style&index=0&id=1fbcd834&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbcd834",
  null
  
)

export default component.exports